<script setup lang="ts">
import { InputField } from '@/components/Fields'
import EditableFieldWrapper from './EditableFieldWrapper.vue'

defineProps<{
    label?: string
    tooltip?: string
    value?: string
    boldLabel?: boolean
    isInEditMode?: boolean
    required?: boolean
    showableElement?: boolean
    errorText?: string
}>()
defineEmits<{ (e: 'change', value: string | undefined): void }>()
</script>

<template>
    <EditableFieldWrapper
        :label="label"
        :tooltip="tooltip"
        :value="value"
        :boldLabel="boldLabel"
        :isInEditMode="isInEditMode"
        :required="required"
        :showableElement="showableElement">
        <InputField
            :modelValue="value"
            @change="$emit('change', $event)"
            :placeholder="label"
            :required="required"
            :errorText="errorText"
            v-bind="$attrs" />
    </EditableFieldWrapper>
</template>
